import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import useAsync from "../hooks/useAsync";
import InvestmentServices from "../services/InvestmentService";
import BookingServices from "../services/BookingServices";
import ViewEarning from "./View Model/ViewEarning";
import ViewDate from "./View Model/VIewDays";
import DeleteButton from "./Button/DeleteButton";
import Modal from "react-modal";
import ReactPaginate from "react-paginate";
import Pagetitle from "./PageTitle";
import * as XLSX from "xlsx";

Modal.setAppElement("#root");

function InvestorEarning() {
  const { data, error, isLoading, run } = useAsync(
    BookingServices.getAllBookingComplete
  );
  // console.log(data);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [earningPerPage] = useState(10);
  const [dateFilter, setDateFilter] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);

  const handleViewDetails = (investment) => {
    setSelectedUser(investment);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1);
  };
  const handleEditDetails = (help) => {
    setSelectedEdit(help);
    setIsEditModalOpen(true);
   
  };
  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString();
    return `${day}-${month}-${year}`;
  };

  const filteredInvestments = (data?.data || []).filter((investment) => {
    const matchesSearch = searchQuery
      ? investment?.property?.investor?.name
        ?.toLowerCase()
        .includes(searchQuery.toLowerCase())
      : true;

    const matchesDate = dateFilter
      ? formatDate(investment?.updatedAt) === formatDate(dateFilter)
      : true;

    return matchesSearch && matchesDate;
  });

  const generateExcel = () => {
    const exportData = filteredInvestments?.map((investment, index) => ({
      Sno: index + 1,
      InvestorName: investment?.property?.investor?.name || "N/A",
      PropertyName: investment?.cottage?.name || "N/A",
      RoomNumber: investment?.room?.roomNumber || "N/A",
      BookingEarnings: investment?.investorEarning || "N/A",
      BookingPercentage: investment?.earningPercentage || "N/A",
      InvoiceNo: investment?.bookingId || "N/A",
      CheckInDate: formatDate(investment?.checkInDate || "N/A"),
      CheckOutDate: formatDate(investment?.checkOutDate || "N/A"),
      Status: investment?.status || "N/A",
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Earning");
    XLSX.writeFile(wb, "Earning_data.xlsx");
  };

  // Pagination Logic
  const indexOfLastUser = currentPage * earningPerPage;
  const indexOfFirstUser = indexOfLastUser - earningPerPage;
  const paginatedInvestment = filteredInvestments.slice(
    indexOfFirstUser,
    indexOfLastUser
  );

  const handleDateChange = (e) => {
    setDateFilter(e.target.value);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  return (
    <div className="right_col" role="main">
      <Pagetitle />
      <div className="container-box px-0 user-manager" style={{ overflowX: "auto", whiteSpace: "nowrap", marginBottom: "20px" }}>
        <div className="container-box-top-header px-4">
          <div className="container-box-top-header-left-2">
            <input
              type="search"
              name="search"
              placeholder="Search Investor"
              value={searchQuery}
              onChange={handleSearchChange}
            />
            <button className="search-btn">
              <FontAwesomeIcon icon={faSearch} />
            </button>
          </div>

          <div className="sub-title-box-right d-flex align-items-center">
            <div>
              <p>Filter By Date:</p>
            </div>
            <div className="ms-3">
              <input type="date" id="dateInput" value={dateFilter} onChange={handleDateChange} />
            </div>
            <button
              className="excel-btn site-btn-green ms-3"
              onClick={generateExcel}
            >
              <img src="img/excel-btn.svg" alt="" />
              <span className="ms-2">Download</span>
            </button>
          </div>
        </div>
        <div className="container-box-inner">
          <table
            id="example"
            className="table table-striped"
            style={{ width: "100%" }}
          >
            <thead>
              <tr>
                <th>S. No.</th>
                <th> Investor Name</th>
                <th>Property Name</th>
                <th>Room  Number</th>
                <th>Booking Earnings</th>
                <th>Booking Percentage</th>
                <th>Invoice No</th>
                <th>Number Of Days</th>
                {/* <th>Check In Date</th>
                <th>Check Out Date</th> */}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedInvestment?.map((investment, index) => (
                <tr key={investment?._id}>
                  <td>{index + 1 + (currentPage - 1) * earningPerPage}</td>
                  <td>{investment?.property?.investor?.name ? investment?.property?.investor?.name : 'N/A'}</td>
                  <td>{investment?.cottage?.name}</td>
                  <td>{investment?.room?.roomNumber}</td>
                  <td>{investment?.investorEarning || 'N/A'}</td>
                  <td>{investment?.earningPercentage || 'N/A'}</td>
                  <td>{investment?.bookingId}</td>
                  <td><a href='javascriptVoid:0'
                    onClick={() => handleEditDetails(investment)}>{investment?.noOfDays || 'N/A'}</a></td>
                  {/* <td>{formatDate(investment?.checkInDate)}</td>
                  <td>{formatDate(investment?.checkOutDate)}</td> */}
                  <td>
                    <button className="edit trans-btn" onClick={() => handleViewDetails(investment)}><img src="img/view-btn.svg" alt="" /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="pagination">
          <ReactPaginate
            pageCount={Math.ceil((filteredInvestments?.length || 0) / earningPerPage)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            activeClassName={"active"}
            previousLabel={"Previous"}
            nextLabel={"Next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            initialPage={currentPage - 1}
            disableInitialCallback={true}
            pageLinkClassName={"page-link"}
            previousLinkClassName={"page-link"}
            nextLinkClassName={"page-link"}
            pageClassName={"page-item"}
            previousClassName={"page-item"}
            nextClassName={"page-item"}
            disabledClassName={"disabled"}
          />
        </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="User Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <ViewEarning investment={selectedUser} closeModal={closeModal} />
      </Modal>
      <Modal
        isOpen={isEditModalOpen}
        onRequestClose={closeEditModal}
        contentLabel="User Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <ViewDate investment={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
      </Modal>
    </div>
  );
}

export default InvestorEarning;
